import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { PurpleOutlinedAlert } from 'Images';

export const FileNote = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);
  return (
    <Stack
      bgcolor={'transparent'}
      borderRadius={'12px'}
      direction={'row'}
      padding={0}
      gap={'12px'}
    >
      <Avatar
        src={PurpleOutlinedAlert}
        sx={{ width: '24px', height: '24px' }}
      />
      <Stack direction={'row'} alignItems={'flex-start'}>
        <Typography variant={'body3'} tabIndex={0}>
          {dictionary.uploadFile.fileInfo}
        </Typography>
      </Stack>
    </Stack>
  );
};
